"use strict";

var constants = require("./index");

module.exports = constants(["PENDING", "FAILED", "DONE"]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/constants/status.js
 ** module id = 471
 ** module chunks = 0
 **/